document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll("[data-password-privacy]").forEach(function (privacy) {
    var modal = privacy.querySelector("[data-password-privacy-modal]");
    var dialog = privacy.querySelector(".password-privacy__dialog");
    var closeButtons = privacy.querySelectorAll("[data-password-privacy-close]");
    var openButtons = document.querySelectorAll("[data-password-privacy-open]");
    var activeOpenButton = null;
    var animationTimeout;

    if (!openButtons.length || !modal || !dialog) return;

    function openPrivacy(event) {
      activeOpenButton = event.currentTarget;
      clearTimeout(animationTimeout);
      modal.hidden = false;
      modal.classList.remove("is-closing");
      document.body.classList.add("overflow-hidden");

      requestAnimationFrame(function () {
        modal.classList.add("is-open");
        dialog.focus();
      });
    }

    function closePrivacy() {
      if (modal.hidden) return;

      clearTimeout(animationTimeout);
      modal.classList.remove("is-open");
      modal.classList.add("is-closing");

      animationTimeout = setTimeout(function () {
        modal.hidden = true;
        modal.classList.remove("is-closing");
        document.body.classList.remove("overflow-hidden");
        if (activeOpenButton) {
          activeOpenButton.focus();
        }
      }, 360);
    }

    openButtons.forEach(function (button) {
      if (button.getAttribute("aria-controls") === modal.id) {
        button.addEventListener("click", openPrivacy);
      }
    });

    closeButtons.forEach(function (button) {
      button.addEventListener("click", closePrivacy);
    });

    document.addEventListener("keydown", function (event) {
      if (event.key === "Escape" && !modal.hidden) {
        closePrivacy();
      }
    });
  });
});
